export function isMobileOrTablet() {
  if (typeof navigator === 'undefined') return false;
  const userAgent = (navigator.userAgent || navigator.vendor || '').toLowerCase();
  const mobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/.test(userAgent);
  const isIPad = /macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
  return mobileUA || isIPad;
}

export const CAMERA_LOCATIONS = [
  'scanpack',
  'next_items',
  'countReceiveRecount',
  'promptBarcode',
  'scanToCart',
];

const COMPATIBLE_LOCATIONS = {
  scanpack: ['scanpack', 'next_items', 'countReceiveRecount'],
  next_items: ['next_items', 'countReceiveRecount'],
  countReceiveRecount: ['countReceiveRecount'],
  promptBarcode: ['promptBarcode'],
  scanToCart: ['scanToCart'],
};

export function isValidCameraLocation(cameraScanner) {
  return cameraScanner && CAMERA_LOCATIONS.includes(cameraScanner.location);
}

export function isCameraOpenElsewhere(cameraScanner, myLocation) {
  if (!cameraScanner || !cameraScanner.isOpen) return false;
  const compatible = COMPATIBLE_LOCATIONS[myLocation] || [myLocation];
  return !compatible.includes(cameraScanner.location);
}
